// Centralized configuration for API endpoints and environment variables
export const API_ORIGIN = import.meta.env.VITE_API_ORIGIN as string;
export const ADMIN_BASE = import.meta.env.VITE_API_ADMIN_BASE as string;
export const APP_TITLE = import.meta.env.VITE_APP_TITLE || "TripNester Admin";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || "1.0.0";

// Environment detection
export const ENV = import.meta.env.MODE || "development";
export const IS_DEVELOPMENT = ENV === "development";
export const IS_PRODUCTION = ENV === "production";
